import uuid from './uuid';

type IKeyStore = 'retail_tokenKey' | 'retail_refreshToken' | 'retail_username' | 'retail_shop_id' | 'retail_device_id' | 'retail_station_number' | 'retail_device_type';

const session = {
  set: (keyValue: IKeyStore, value: string) => {
    return sessionStorage.setItem(keyValue, value);
  },

  get: (keyValue: IKeyStore) => {
    return sessionStorage.getItem(keyValue);
  },
};

const local = {
  set: (keyValue: IKeyStore, value: string) => {
    return localStorage.setItem(keyValue, value);
  },

  get: (keyValue: IKeyStore) => {
    return localStorage.getItem(keyValue);
  },
};

const genGetSetKeyLocal = (key: IKeyStore) => ({
  get: () => local.get(key) ?? '',
  set: (value: string) => local.set(key, value),
});

const genGetSetKeySession = (key: IKeyStore) => ({
  get: () => session.get(key) ?? '',
  set: (value: string) => session.set(key, value),
});

export const getDeviceId = () => {
  const device_id = storage.device_id.get();
  if (device_id) return device_id;
  const new_device_id = uuid();
  storage.device_id.set(new_device_id);
  return new_device_id;
};

const storage = {
  get: session.get,
  set: session.set,
  genGetSetKeyLocal,
  genGetSetKeySession,
  token: genGetSetKeyLocal('retail_tokenKey'),
  refreshToken: genGetSetKeyLocal('retail_refreshToken'),
  username: genGetSetKeyLocal('retail_username'),
  device_id: genGetSetKeyLocal('retail_device_id'),
  station_number: genGetSetKeyLocal('retail_station_number'),
  shop_id: genGetSetKeyLocal('retail_shop_id'),
  device_type: genGetSetKeyLocal('retail_device_type'),
};

export default storage;
